///
/// EarthBrowser
///
/// Created by Matt Giger on 9/23/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Click-to-draw story annotations: while the editor has a drawing in
/// progress (dialog.storyDrawing), taps on the globe append points
/// (marker = one click, arc = two+, region = three+ ring). The recognizer
/// outranks entity taps (priority 30 > EntityTapHandler's 20) so drawing
/// over a webcam pin adds a point instead of focusing the webcam, and is
/// disabled entirely when no drawing is active so normal interaction is
/// untouched. Camera drags still navigate between clicks - a tap that
/// moves past the threshold fails and pan takes over.
///

import { engineActions, engineBridge } from "@/earthbrowser/engineBridge"
import { geographic } from "@/earthbrowser/utils/geographic"
import { TapGestureRecognizer } from "@stovokor/gestures/TapGestureRecognizer"
import { trig } from "@stovokor/math"
import { type Earth } from "../Earth"

export class StoryDrawHandler extends TapGestureRecognizer {
	private unsubscribeRedux?: () => void

	constructor(earth: Earth) {
		super({ maximumTouches: 1 })
		this.priority = 30
		this.enabled = false
		earth.addRecognizer(this)

		this.onGesture(data => {
			const hit = data.ownerHits[0]?.hitPoint
			if (!hit) return
			const geo = new geographic(hit)
			engineBridge.dispatch({
				type: engineActions.addStoryDrawingPoint,
				payload: { lat: geo.latitude * trig.deg, lon: geo.longitude * trig.deg },
			})
		})

		// Only claim taps while a drawing is active
		const apply = () => {
			const drawing = engineBridge.getState()?.dialog.storyDrawing ?? null
			this.enabled = drawing !== null
		}
		apply()
		this.unsubscribeRedux = engineBridge.subscribe(apply)
	}

	public destroy(): void {
		this.unsubscribeRedux?.()
	}
}
